















































































































































































































































































































































































































import { Component, Vue, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import _ from 'lodash'
import { Auth } from '@finx/web-repository/src/services/Oidc'
import CadastroMedicoStore from '@/components/CadastroMedico/store/CadastroMedicoStore'
import SnackbarStore from '@/components/Snackbar/Store/SnackbarStore'
import { getSnackbarMessage, onlyNumber, validateCPF, validateEmail } from '@/utils/common'
import { IRequestMessage, RequestMessage, Snackbar, TipoConviteEnum, StatusEmailEnum, CadastroMedico } from '@/types/_'
import signalR from '@/signalR/signalR'
import EventBus from '@/plugins/EventBus'
import TermosDeAceiteFinx from '@/components/TermosAceites/TermosDeAceiteFinx.vue'
import TermosDeAceiteBP from '@/components/TermosAceites/TermosDeAceiteBP.vue'
import SegurancaApi from '@/Apis/Seguranca/Services/SegurancaApi'
import ModalCadastroMedicoSecretaria from '@/components/CadastroMedico/Modals/ModalCadastroMedicoSecretaria.vue'
import { SecretariaMedicoValidation } from '../store/Validation/Validation'

interface VDatePicker extends Vue {
  save(date: any): any
}

@Component({
  components: {
    TermosDeAceiteFinx,
    TermosDeAceiteBP,
    ModalCadastroMedicoSecretaria,
  },
})
export default class ComponentCadastroMedico extends Vue {
  $refs!: {
    menu: VDatePicker,
    picker: VDatePicker,
    formRules: any,
    formTermosAceiteRules: any,
  }

  loadSalvar: boolean = false
  loadEmail: boolean = false
  dial: boolean = false
  menu: Boolean = false
  conviteId: string = ''
  qrCode: string = ''
  files: any[] = []
  enableProgressCircular: boolean = false
  emailSecretariaLoading: boolean = false
  emailValid: boolean = false
  cpfValid: boolean = false
  loadingSignature: boolean = false

  get loadingEmail() {
    return this.loadEmail
  }

  set loadingEmail(value: boolean) {
    this.loadEmail = value
  }

  get loadingSalvar() {
    return this.loadSalvar
  }

  set loadingSalvar(value: boolean) {
    this.loadSalvar = value
  }

  get modalCadastroMedicoDialog() {
    return this.dial
  }

  set modalCadastroMedicoDialog(value: boolean) {
    this.dial = value
  }

  get getCadastroMedicoStore() {
    return getModule(CadastroMedicoStore, this.$store)
  }

  get getSnackbarStore() {
    return getModule(SnackbarStore, this.$store)
  }

  get maximumDate() {
    const [year, month, day] = new Date().toISOString().substr(0, 10).split('-')
    return `${parseInt(year, 10) - 18}-${month}-${day}`
  }

  get especialidades() {
    return this.getCadastroMedicoStore.especialidadesLista
  }

  get getHospitais() {
    return this.getCadastroMedicoStore.hospitais
  }

  get getUf() {
    const ufs: any[] = []
    ufs.push({ id: 'AC', value: 'AC' })
    ufs.push({ id: 'AL', value: 'AL' })
    ufs.push({ id: 'AP', value: 'AP' })
    ufs.push({ id: 'AM', value: 'AM' })
    ufs.push({ id: 'BA', value: 'BA' })
    ufs.push({ id: 'CE', value: 'CE' })
    ufs.push({ id: 'DF', value: 'DF' })
    ufs.push({ id: 'ES', value: 'ES' })
    ufs.push({ id: 'GO', value: 'GO' })
    ufs.push({ id: 'MA', value: 'MA' })
    ufs.push({ id: 'MT', value: 'MT' })
    ufs.push({ id: 'MS', value: 'MS' })
    ufs.push({ id: 'MG', value: 'MG' })
    ufs.push({ id: 'PA', value: 'PA' })
    ufs.push({ id: 'PB', value: 'PB' })
    ufs.push({ id: 'PR', value: 'PR' })
    ufs.push({ id: 'PE', value: 'PE' })
    ufs.push({ id: 'PI', value: 'PI' })
    ufs.push({ id: 'RJ', value: 'RJ' })
    ufs.push({ id: 'RN', value: 'RN' })
    ufs.push({ id: 'RS', value: 'RS' })
    ufs.push({ id: 'RO', value: 'RO' })
    ufs.push({ id: 'RR', value: 'RR' })
    ufs.push({ id: 'SC', value: 'SC' })
    ufs.push({ id: 'SP', value: 'SP' })
    ufs.push({ id: 'SE', value: 'SE' })
    ufs.push({ id: 'TO', value: 'TO' })
    return ufs
  }

  get getRequestMessage() {
    const requestMessage: IRequestMessage = new RequestMessage()
    return requestMessage
  }

  get getConviteId() {
    return this.conviteId
  }

  set getConviteId(value: string) {
    this.conviteId = value
  }

  get getQrCode() {
    return this.qrCode
  }

  set getQrCode(qrCode: string) {
    this.qrCode = qrCode
  }

  get getEnableProgressCircular() {
    return this.enableProgressCircular
  }

  set getEnableProgressCircular(value) {
    this.enableProgressCircular = value
  }

  get templateTermosDeAceite() {
    const { termo } = this.getCadastroMedicoStore.cadastroMedico.termoAceite
    return (termo && termo.toUpperCase() === 'BP') ? 'BP' : 'Finx'
  }

  openAssinatura() {
    window.open(`/assinatura/${this.conviteId}/backpage`, '_blank')
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

  async generateQrCode(conviteId: string) {
    const qrCodeResponse = await this.getCadastroMedicoStore.generateQrCode(conviteId)
    return qrCodeResponse
  }

  async refreshSignature() {
    try {
      this.loadingSignature = true

      await this.getCadastroMedicoStore.getConviteUsuario()
    } catch (error) {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Houve um erro ao buscar assinatura, tente novamente', 'error'))
    } finally {
      this.loadingSignature = false
    }
  }

  termosAceiteRules: any = {
    valid: false,
    termosAceites: [(v: any) => !!v || 'O campo termos de aceites é obrigatório.'],
  }

  formRules: any = {
    valid: true,
    nomeSecretaria: [(v: any) => this.validaNomeSecretariaNulo(v) || 'O campo deve ser acima de 6 caracteres.'],
    emailRules: [
      (v: any) => !!v || 'O campo E-mail é obrigatório.',
      (v: any) => validateEmail(v) || 'O E-mail deve ser válido.',
    ],
    emailSecretariaRules: [(v: any) => this.validaEmailNuloSecretaria(v) || 'O E-mail deve ser válido.'],
    nome: [(v: any) => !!v || 'O campo Nome é obrigatório.'],
    cpf: [
      (v: any) => !!v || 'O campo CPF é obrigatório.',
      (v: any) => !!validateCPF(v) || 'CPF inválido.',
    ],
    sexo: [(v: any) => !!v || 'O campo Sexo é obrigatório.'],
    conselhoNumero: [(v: any) => !!v || 'O campo Número é obrigatório.'],
    conselhoUf: [(v: any) => !!v || 'O campo Uf é obrigatório.'],
    celular: [(v: any) => !!v || 'O campo Celular é obrigatório.'],
    especialidade: [
      (v: any) => !!v || 'O campo Especialidade é obrigatório.',
      (v: any) => !!v.length || 'O campo Especialidade é obrigatório.',
    ],
    assinatura: [(v: any) => !!v || 'O campo Assinatura é obrigatório.'],
  }

  validaNomeSecretariaNulo(nome: string) {
    if (!nome) {
      return true
    }

    return nome.length > 5
  }

  validaEmailNuloSecretaria(email) {
    if (email) {
      return validateEmail(email)
    }

    return true
  }

  checkEmailSecretariaDebounce = _.debounce(input => this.checkEmailSecretaria(input), 500)

  searchCheckEmailSecretaria(input) {
    this.checkEmailSecretariaDebounce(input)
  }

  async checkEmailSecretaria(email: string) {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.post)
    const { secretariasMedico } = this.getCadastroMedicoStore
    let validEmails: boolean = true

    if (validateEmail(email)) {
      const result = this.validarEmailDuplicado(email)

      if (result) {
        secretariasMedico.map((c) => {
          const m = c
          m.mensagem = ''
          return m
        })
      } else {
        secretariasMedico.map((c) => {
          const m = c
          if (m.email === email) {
            m.mensagem = 'Email duplicado.'
          } else {
            m.mensagem = ''
          }
          return m
        })
      }

      await Promise.all(
        secretariasMedico.map(async (c) => {
          const d = { ...c }
          validEmails = true
          d.mensagem = ''

          return d
        }),
      )
    } else {
      secretariasMedico.map((c) => {
        const m = c
        if (email && m.email === email) {
          m.mensagem = 'Email inválido.'
        } else {
          m.mensagem = ''
        }
        return m
      })
    }

    this.clearLoadingRequest()
  }

  // eslint-disable-next-line
  validarEmailDuplicado(v) {
    if (v) {
      let isValid: boolean = true
      const { secretariasMedico } = this.getCadastroMedicoStore
      if (v === this.getCadastroMedicoStore.cadastroMedico.email) {
        isValid = false
        this.emailValid = false
      } else {
        const e = (secretariasMedico.length > 1 && secretariasMedico.filter(c => c.email === v || c.email === this.getCadastroMedicoStore.cadastroMedico.email).length > 1)
        this.emailValid = !e
        return !e
      }
    } else {
      return true
    }
  }

  clearEmail() {
    this.getCadastroMedicoStore.cadastroMedico.cpf = ''
    return true
  }

  removeEspecialidade(item: any) {
    this.getCadastroMedicoStore.removeEspecialidades(item)
  }

  removeHospitais(item: any) {
    this.getCadastroMedicoStore.removeHospitais(item)
  }

  clearSecretariaMedica() {
    this.getCadastroMedicoStore.clearSecretariaMedica()
  }

  addCadastroSecretaria() {
    if (this.isSecretariaValid()) {
      this.getCadastroMedicoStore.addCadastroSecretariaMedico()
    }
  }

  removeSecretaria(value: number) {
    this.getCadastroMedicoStore.removeSecretariaMedico(value)
    this.emailValid = true
  }

  async verifyCpf() {
    const cpf = this.getCadastroMedicoStore.cadastroMedico.cpf ? this.getCadastroMedicoStore.cadastroMedico.cpf.toString() : ''
    if (!this.getCadastroMedicoStore.cadastroMedico.loginCadastrado && validateCPF(cpf)) {
      this.getCadastroMedicoStore.cadastroMedicoMessage.cpf = ''
    } else {
      this.getCadastroMedicoStore.cadastroMedicoMessage.cpf = 'CPF inválido'
    }
  }

  async salvar() {
    this.loadingSalvar = true

    if (this.validarCadastro()) {
      let { cadastroMedico } = this.getCadastroMedicoStore
      cadastroMedico.tipoConvite = TipoConviteEnum.MedicoAgendamento
      cadastroMedico = this.verificaExisteSecretarias(cadastroMedico)
      const response = await this.getCadastroMedicoStore.sendCadastroMedico(cadastroMedico)
      if (response.success) {
        this.modalCadastroMedicoDialog = true
      } else {
        // Caso o usuário já esteja cadastrado (e-mail), o back retorna a mensagem "Já existe uma pessoa cadastrada com este email!"
        const emailExisteMessage = 'Já existe uma pessoa cadastrada com este email!'
        if (response.message && response.message === emailExisteMessage) {
          this.getCadastroMedicoStore.cadastroMedicoMessage.email = response.message
        }
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message, 'error'))
      }
    } else {
      EventBus.$emit('setSnackbar', getSnackbarMessage('Por favor informe o(s) campo(s) corretamente.', 'error'))
    }

    this.loadingSalvar = false
  }

  validarCadastro() {
    const form1 = this.$refs.formRules.validate()
    let form2 = true
    if (this.getCadastroMedicoStore.cadastroMedico.termoAceite.exibeTermo) form2 = this.$refs.formTermosAceiteRules.validate()
    if (this.getCadastroMedicoStore.cadastroMedico.assinatura) this.getCadastroMedicoStore.cadastroMedicoMessage.assinatura = ''
    else this.getCadastroMedicoStore.cadastroMedicoMessage.assinatura = 'Por favor informe a assinatura pelo Qr-Code.'
    return form1
      && form2
      // && this.isSecretariaValid() --> Temporariamente removido - #FXCS-5677
      && this.formRules.valid
      && this.getCadastroMedicoStore.cadastroMedico.assinatura
  }

  verificaExisteSecretarias(cadastroMedico: CadastroMedico) {
    const temp = cadastroMedico
    if (this.getCadastroMedicoStore.secretariasMedico.length === 1
      && this.getCadastroMedicoStore.secretariasMedico[0].nome) {
      temp.secretarias = this.getCadastroMedicoStore.secretariasMedico
    }

    if (this.getCadastroMedicoStore.secretariasMedico.length > 1) {
      temp.secretarias = this.getCadastroMedicoStore.secretariasMedico
    }
    return temp
  }

  async redirect() {
    await Auth.login('./')
    this.clearLoadingRequest()
  }

  async closeRedirectionModal() {
    await this.redirect()
    this.modalCadastroMedicoDialog = false
  }

  isSecretariaValid() {
    if (this.getCadastroMedicoStore.secretariasMedico.length === 1
      && this.getCadastroMedicoStore.secretariasMedico[0].nome === ''
      && this.getCadastroMedicoStore.secretariasMedico[0].email === '') {
      return true
    }

    const cadastroMedicoValidation = new SecretariaMedicoValidation()
    const secretariaValidation = cadastroMedicoValidation.formMedicoSecretariaValidate(this.getCadastroMedicoStore.secretariasMedico, this.getCadastroMedicoStore.cadastroMedico.email)
    return secretariaValidation.success
  }

  formatDate(date) {
    if (!date) return null

    const [year, month, day] = date.split('-')
    return `${day}/${month}/${year}`
  }

  toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })

  async inputFile(newFile, oldFile) {
    if (newFile.identifier) {
      return
    }

    this.getCadastroMedicoStore.cadastroMedico.assinatura = ''
    this.getEnableProgressCircular = true

    const imageBase64 = await this.toBase64(newFile.file)

    const params: any = {
      conviteId: this.$route.params.conviteId,
      // @ts-ignore
      assinatura: imageBase64.toString().replace('data:image/png;base64,', ''),
    }

    const response = await this.getCadastroMedicoStore.uploadAssinatura(params)
    if (response.success) {
      // Faz alguma coisa...
    } else {
      const snackbar: Snackbar = {
        disabled: true,
        disabledBtn: true,
        show: true,
        timeout: 6000,
        message: this.getRequestMessage.errorApi,
      }

      this.getSnackbarStore.setSnackbar(snackbar)
    }
  }

  save(date: any) {
    this.$refs.menu.save(date)
  }

  onlyNumberUtil(value) {
    return onlyNumber(value)
  }

  loadImageAssinatura(value) {
    if (_.toLower(value.ConviteId) === _.toLower(this.getConviteId)) {
      this.getEnableProgressCircular = true
      this.getCadastroMedicoStore.cadastroMedico.assinatura = ''
      setTimeout(() => {
        this.getEnableProgressCircular = false
        this.getCadastroMedicoStore.cadastroMedico.assinatura = value.Assinatura
        this.getCadastroMedicoStore.cadastroMedicoMessage.assinatura = ''
      }, 2000)
    }
  }

  async Init() {
    this.setLoadingRequest(this.getRequestMessage.status, this.getRequestMessage.init.text)
    await this.getCadastroMedicoStore.getCbosAll()
    this.getConviteId = this.$route.params.conviteId

    await signalR.start(this.getConviteId)

    if (!this.isMobile()) {
      this.getQrCode = await this.generateQrCode(this.getConviteId)
    }
    this.clearLoadingRequest()
  }

  async created() {
    await this.Init()
  }

  async mounted() {
    EventBus.$on('loadImageAssinatura', value => this.loadImageAssinatura(JSON.parse(value)))
  }

  clearLoadingRequest() {
    this.setLoadingRequest(false, '')
  }

  @Emit('setLoadingRequest')
  setLoadingRequest(status, text) { }
}
